import React from 'react';
import VideoSlider from "../YoutubeVideo";

const VideoSection = ({ h3Ref2Home, videoUrls }) => {
    return (
        <div className="container-fluid mt-2">
            <div className="row justify-content-center">
                <div className="col-lg-8 pb-3">
                    <div className="Faqtitle home-slider">
                        <h3 className="border-bottom-animation h3hoverbefore" ref={h3Ref2Home}>Creating a Difference for Everyone</h3>
                        <br />
                    </div>
                </div>
                <br />
                <div className="col-md-12 pb-5 pt-3">
                    <VideoSlider videoUrls={videoUrls} />
                </div>
            </div>
        </div>
    );
};

export default React.memo(VideoSection);
